// 1つ目のスライダー（クラス名 .splide1）
const splide1El = document.querySelector(".splide1");
if (splide1El) {
  new Splide(splide1El, {
  type: "loop", // ループ
  autoplay: true, // 自動再生
  interval: 3000, // 自動再生の間隔
  speed: 1000, // スライダーの移動時間
  perPage: 1.5,
  focus: "center", // スライドの中央に表示
  arrows: false, // 矢印ボタンを非表示
  pagination: false, // ページネーションを非表示
  perMove: 1, // 1枚ずつスライド
  clones: 3, // 前後に2枚の複製を表示
  rewind: true, // ループ時に戻るアニメーションを有効
  breakpoints: {
    768: {
      perPage: 1,
    },
  },
  }).mount();
}

// 2つ目のスライダー（クラス名 .splide2）
const splide2El = document.querySelector(".splide2");
if (splide2El) {
  new Splide(splide2El, {
  type: "loop", // ループ
  autoplay: true, // 自動再生
  interval: 3000, // 自動再生の間隔
  speed: 1000, // スライダーの移動時間
  perPage: 4.8,
  gap: "32px",
  arrows: false, // 矢印ボタンを非表示
  pagination: false, // ページネーションを非表示
  perMove: 1, // 1枚ずつスライド
  clones: 6, // 前後に6枚の複製を表示
  rewind: true, // ループ時に戻るアニメーションを有効
  breakpoints: {
    768: {
      perPage: 2.3,
      gap: "16px",
    },
  },
  }).mount();
}

// 3つ目のスライダー（クラス名 .splide3）
const splide3El = document.querySelector(".splide3");
if (splide3El) {
  new Splide(splide3El, {
  type: "loop", // ループ
  autoplay: true, // 自動再生
  interval: 3000, // 自動再生の間隔
  speed: 1000, // スライダーの移動時間
  perPage: 4.8,
  gap: "32px",
  arrows: false, // 矢印ボタンを非表示
  pagination: false, // ページネーションを非表示
  perMove: 1, // 1枚ずつスライド
  clones: 6, // 前後に6枚の複製を表示
  rewind: true, // ループ時に戻るアニメーションを有効
  direction: "rtl", // 右から左にスライド
  breakpoints: {
    768: {
      perPage: 2.3,
      gap: "16px",
    },
  },
  }).mount();
}

// 4つ目のスライダー（クラス名 .splide4）
const splide4El = document.querySelector(".splide4");
if (splide4El) {
  new Splide(splide4El, {
  type: "loop", // ループ
  focus: "center", // スライドの中央に表示
  gap: "32px",
  pagination: false, // ページネーションを非表示
  perMove: 1, // 1枚ずつスライド
  clones: 6, // 前後に6枚の複製を表示
  rewind: true, // ループ時に戻るアニメーションを有効
  breakpoints: {
    1024: {
      gap: "24px",
    },
    768: {
      perPage: 1,
    },
  },
  }).mount();
}

// トグルメニュー point用
document.addEventListener("DOMContentLoaded", function () {
  const cards = document.querySelectorAll(".point_card");

  function updateAccordion() {
    const isMobile = window.innerWidth <= 768;

    cards.forEach((card) => {
      const button = card.querySelector(".point_cardTitle");
      const content = card.querySelector(".point_cardContent");
      const icon = button.querySelector(".point_cardToggleIcon");

      if (isMobile) {
        // スマホ時のみトグル機能を適用
        content.style.maxHeight = "0px";
        content.style.opacity = "0";

        button.addEventListener("click", function () {
          const isOpen = content.style.maxHeight !== "0px";

          document.querySelectorAll(".point_cardContent").forEach((el) => {
            el.style.maxHeight = "0px";
            el.style.opacity = "0";
          });

          document.querySelectorAll(".point_cardToggleIcon").forEach((el) => {
            el.style.transform = "rotate(0deg)";
          });

          if (!isOpen) {
            content.style.maxHeight = content.scrollHeight + "px";
            content.style.opacity = "1";
            icon.style.transform = "rotate(180deg)";
          }
        });
      } else {
        // PCではすべて開いた状態
        content.style.maxHeight = "none";
        content.style.opacity = "1";
      }
    });
  }

  updateAccordion(); // 初回実行
  window.addEventListener("resize", updateAccordion); // 画面サイズ変更時に適用
});

// トグルメニュー point02用
document.addEventListener("DOMContentLoaded", function () {
  const cards = document.querySelectorAll(".point02_card");

  function updateAccordion() {
    const isMobile = window.innerWidth <= 768;

    cards.forEach((card) => {
      const button = card.querySelector(".point02_cardTitle");
      const content = card.querySelector(".point02_cardContent");
      const icon = button.querySelector(".point02_cardToggleIcon");

      if (isMobile) {
        // スマホ時のみトグル機能を適用
        content.style.maxHeight = "0px";
        content.style.opacity = "0";

        button.addEventListener("click", function () {
          const isOpen = content.style.maxHeight !== "0px";

          document.querySelectorAll(".point02_cardContent").forEach((el) => {
            el.style.maxHeight = "0px";
            el.style.opacity = "0";
          });

          document.querySelectorAll(".point02_cardToggleIcon").forEach((el) => {
            el.style.transform = "rotate(0deg)";
          });

          if (!isOpen) {
            content.style.maxHeight = content.scrollHeight + "px";
            content.style.opacity = "1";
            icon.style.transform = "rotate(180deg)";
          }
        });
      } else {
        // PCではすべて開いた状態
        content.style.maxHeight = "none";
        content.style.opacity = "1";
      }
    });
  }

  updateAccordion(); // 初回実行
  window.addEventListener("resize", updateAccordion); // 画面サイズ変更時に適用
});

// PC用のフロートメニュー
document.addEventListener("DOMContentLoaded", function () {
  const mvFloat = document.querySelector(".mv_float");
  const mvSection = document.querySelector(".mv");

  if (window.innerWidth >= 769 && mvFloat && mvSection) {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) {
          mvFloat.classList.add("show"); // .mv を過ぎたら表示
        } else {
          mvFloat.classList.remove("show"); // .mv が見えていたら非表示
        }
      },
      { threshold: 0.1 } // 10% 以上見えたら判定
    );

    observer.observe(mvSection);
  }
});

// SP用のフロートメニュー
document.addEventListener("DOMContentLoaded", function () {
  const mvFloatBtnWrap = document.querySelector(".mv_floatBtnWrap");
  const mvSection = document.querySelector(".mv");

  if (window.innerWidth <= 768 && mvFloatBtnWrap && mvSection) {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) {
          mvFloatBtnWrap.classList.add("show"); // .mv を過ぎたら表示
        } else {
          mvFloatBtnWrap.classList.remove("show"); // .mv が見えていたら非表示
        }
      },
      { threshold: 0.1 } // 10% 以上見えたら判定
    );

    observer.observe(mvSection);
  }
});
// SP用のフロートメニュー
document.addEventListener("DOMContentLoaded", function () {
  const mvFloat = document.querySelector(".mv_float");
  const mvSection = document.querySelector(".mv");

  if (window.innerWidth <= 768 && mvFloat && mvSection) {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) {
          mvFloat.classList.add("mv_float_hidden"); // .mv を過ぎたら表示
        } else {
          mvFloat.classList.remove("mv_float_hidden"); // .mv が見えていたら非表示
        }
      },
      { threshold: 0.1 } // 10% 以上見えたら判定
    );

    observer.observe(mvSection);
  }
});

// faqのトグル
document.addEventListener("DOMContentLoaded", function () {
  const faqItems = document.querySelectorAll(".faq_item");

  faqItems.forEach((item) => {
    const question = item.querySelector(".faq_question");

    question.addEventListener("click", function () {
      item.classList.toggle("active");

      // 他のFAQを閉じる（アコーディオンの単一開閉）
      faqItems.forEach((otherItem) => {
        if (otherItem !== item) {
          otherItem.classList.remove("active");
        }
      });
    });
  });
});
